var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#764ABC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M354.75,352.37c18.94-1.96,33.24-18.24,32.54-37.73c-0.7-19.5-16.97-35.21-36.47-35.21h-1.26 c-20.2,0.7-35.77,17.53-35.21,37.73c0.7,9.82,4.63,18.24,10.38,24.13c-22.16,43.62-55.97,75.61-106.89,102.26 c-34.51,18.24-70.42,24.83-106.19,20.2c-29.32-3.93-52.18-16.97-66.49-38.43c-20.9-31.98-22.86-66.49-5.19-101 c12.34-24.83,31.98-43.06,44.33-52.18c-2.67-8.42-6.45-22.86-8.42-33.24c-94.4,68.45-84.72,160.89-55.97,204.66 c21.46,32.54,65.09,52.74,113.34,52.74c13.05,0,26.09-1.26,39.14-4.63C255.72,475.53,318.98,426.01,354.75,352.37z M469.49,271.57 c-49.52-57.93-122.46-89.92-205.92-89.92h-10.38c-5.89-11.78-18.24-19.5-31.98-19.5h-1.26c-20.2,0.7-35.77,17.53-35.21,37.73 c0.7,19.5,16.97,35.21,36.47,35.21h1.26c14.31-0.7,26.65-9.82,31.98-22.16h11.78c49.52,0,96.37,14.31,138.73,42.36 c32.54,21.46,55.97,49.52,69.01,83.46c11.08,27.35,10.38,54.15-1.26,76.87c-18.24,34.51-48.82,53.44-89.21,53.44 c-26.09,0-50.78-7.86-63.82-13.75c-7.15,6.45-20.2,16.97-29.32,23.43c28.05,13.05,56.67,20.2,84.02,20.2 c62.56,0,108.85-34.51,126.39-69.01C519.57,392.21,518.31,326.98,469.49,271.57z M138.45,363.45c0.7,19.5,16.97,35.21,36.47,35.21 h1.26c20.2-0.7,35.77-17.53,35.21-37.73c-0.7-19.5-16.97-35.21-36.47-35.21h-1.26c-1.26,0-3.23,0-4.63,0.7 c-26.65-44.33-37.73-92.58-33.95-144.62c2.67-39.14,15.57-72.94,38.43-101c18.94-24.13,55.41-35.77,80.1-36.47 c69.01-1.26,98.33,84.72,100.3,119.23c8.42,1.96,22.86,6.45,32.54,9.82C378.6,67.89,313.51,13.05,250.95,13.05 c-58.63,0-112.78,42.36-134.24,104.92c-30.02,83.46-10.38,163.56,26.09,226.68C139.71,349.14,137.75,356.3,138.45,363.45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.0945008a420c968920118a186b9c9746.svg";
export { ForwardRef as ReactComponent };